import { useTranslation } from 'react-i18next'
import { useContext, useEffect, useState } from 'react'

import { countriesCurrencies } from '../lib'
import { numberWithCommas } from '../utils'
import { AppStateContext } from '../contexts'
import '../styles/reports-brief-management.css'
import ChartIcon from '../assets/icons/chart-icon.svg'
import AccountIcon from '../assets/icons/account-icon.svg'
import MoneyGreenIcon from '../assets/icons/money-icon-green.svg'
import ContractDeleteIcon from '../assets/icons/contract-delete-icon.svg'
import { ReportSquareContainer } from '../components/reports-brief-management/report-square-container'

const ReportsBriefManagement = () => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
  const currency = (countriesCurrencies as { [key: string]: string })[selectedCountry].toUpperCase()

  const { t } = useTranslation(['reports-management'])
  const { homeStats } = useContext(AppStateContext)

  const [tradedVolume, setTradedVolume] = useState<number>(0)
  const [dataFullyLoaded, setDataFullyLoaded] = useState(false)
  const [paymentsQuantity, setPaymentsQuantity] = useState<number>(0)
  const [paymentsPaidQuantity, setPaymentsPaidQuantity] = useState<number>(0)
  const [tradedVolumeThisWeek, setTradedVolumeThisWeek] = useState<number>(0)
  const [noveltiesSolvedQuantity, setNoveltiesSolvedQuantity] = useState<number>(0)
  const [queriesOfRestrictiveList, setQueriesOfRestrictiveList] = useState<number>(0)
  const [paymentsErrorOrRejectedQuantity, setPaymentsErrorOrRejectedQuantity] = useState<number>(0)
  const [noveltiesSolvedQuantityThisWeek, setNoveltiesSolvedQuantityThisWeek] = useState<number>(0)
  const [queriesOfRestrictiveListThisWeek, setQueriesOfRestrictiveListThisWeek] = useState<number>(0)

  useEffect(() => {
    if (homeStats) {
      handleSetInitialData(homeStats)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeStats])

  const handleSetInitialData = async (dataToSet: any) => {
    setTradedVolume(dataToSet.paymentStats[0].amountSum)
    setPaymentsQuantity(dataToSet.paymentStats[0].totalDocs)
    setQueriesOfRestrictiveList(dataToSet.paymentStats[0].totalDocs)
    setNoveltiesSolvedQuantity(dataToSet.paymentsWithNoveltiesApproved)
    setTradedVolumeThisWeek(dataToSet.paymentStats[0].thisWeek.amountSum)
    setQueriesOfRestrictiveListThisWeek(dataToSet.paymentStats[0].thisWeek.totalDocs)
    setNoveltiesSolvedQuantityThisWeek(dataToSet.paymentsWithNoveltiesApprovedThisWeek)
    setPaymentsPaidQuantity(Number(dataToSet.paymentStats[0].statusCounts.paid) + Number(dataToSet.paymentStats[0].statusCounts.validated))
    setPaymentsErrorOrRejectedQuantity(Number(dataToSet.paymentStats[0].statusCounts.rejected) + Number(dataToSet.paymentStats[0].statusCounts.returned))
    setDataFullyLoaded(true)
  }

  return (
    <>
      <div className="title-module-container">
        <h1 className="banks-balances-title">{t('title')}</h1>
      </div>
      <div className="reports-row-container">
        <ReportSquareContainer
          showMainIcon
          icon={ChartIcon}
          showSecondaryData
          dataFullyLoaded={dataFullyLoaded}
          reportName={t('reportsNames.tradedVolume')}
          mainData={`$ ${numberWithCommas(Number(tradedVolume || 0).toFixed(2))} ${currency}`}
          secondaryData={t('secondaryData', { figureData: `$ ${numberWithCommas(Number(tradedVolumeThisWeek || 0).toFixed(2))} ${currency}` })}
        />
        <ReportSquareContainer
          showMainIcon
          showSecondaryData
          icon={ContractDeleteIcon}
          dataFullyLoaded={dataFullyLoaded}
          mainData={`${numberWithCommas(queriesOfRestrictiveList)}`}
          reportName={t('reportsNames.queriesOnRestrictiveLists')}
          secondaryData={t('secondaryData', { figureData: `${numberWithCommas(queriesOfRestrictiveListThisWeek)}` })}
        />
        <ReportSquareContainer
          showMainIcon
          showSecondaryData
          icon={AccountIcon}
          dataFullyLoaded={dataFullyLoaded}
          reportName={t('reportsNames.beneficiaryNovelties')}
          mainData={`${numberWithCommas(noveltiesSolvedQuantity)}`}
          secondaryData={t('secondaryData', { figureData: `${numberWithCommas(noveltiesSolvedQuantityThisWeek)}` })}
        />
        <ReportSquareContainer
          showMainIcon
          icon={MoneyGreenIcon}
          showSecondaryData={false}
          backgroundColor="#CCFBEF"
          dataFullyLoaded={dataFullyLoaded}
          reportName={t('reportsNames.paymentsMade')}
          mainData={`${numberWithCommas(paymentsQuantity)}`}
        />
        <ReportSquareContainer
          showMainIcon
          showCheckIcon
          icon={MoneyGreenIcon}
          showSecondaryData={false}
          backgroundColor="#CCFBEF"
          dataFullyLoaded={dataFullyLoaded}
          reportName={t('reportsNames.successfulPayments')}
          mainData={`${numberWithCommas(paymentsPaidQuantity)}`}
        />
        <ReportSquareContainer
          showMainIcon
          showCancelIcon
          icon={MoneyGreenIcon}
          showSecondaryData={false}
          backgroundColor="#CCFBEF"
          dataFullyLoaded={dataFullyLoaded}
          reportName={t('reportsNames.rejectedPayments')}
          mainData={`${numberWithCommas(paymentsErrorOrRejectedQuantity)}`}
        />
      </div>
    </>
  )
}

export default ReportsBriefManagement
